// auto-generated by {apiBaseUrl}/tools/typescriptmodels
export class TrackingModel {
	public CreatedOnUTC: Date = new Date();
	public CreateUserUID: string = "";
	public ModifiedOnUTC?: Date;
	public ModifyUserUID?: string;
	public DeletedOnUTC?: Date;
	public DeleteUserUID?: string;
}